import type { AppThunk } from '@core/core/store'
import type { ProjectId } from 'common/types'

import { getAllFieldsApi, getFieldByProjectIdApi } from '../../api'
import { addFieldToProject } from '../project'
import { fieldsSlice } from './fieldSlice'

const { addFields } = fieldsSlice.actions

export const getFields = (): AppThunk => dispatch => {
  getAllFieldsApi()
    .then(fields => dispatch(addFields(fields)))
    .catch(console.error)
}

export const getFieldsByProjectId =
  (projectId: ProjectId): AppThunk =>
  dispatch => {
    getFieldByProjectIdApi(projectId)
      .then(fields => dispatch(addFieldToProject(fields)))
      .catch(console.error)
  }
